import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/

// Redes sociales — REEMPLAZAR los href '#' por las URLs reales de Bacon
const REDES = [
  {
    nombre: 'LinkedIn',
    url: 'https://www.linkedin.com/company/laboratoriosbacon/',
    path: 'M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z',
  },
  {
    nombre: 'Instagram',
    url: 'https://www.instagram.com/laboratoriosbacon/',
    path: 'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.12 1.38C1.36 2.67.94 3.34.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.12.66.66 1.33 1.08 2.12 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.3 1.46-.72 2.12-1.38.66-.66 1.08-1.33 1.38-2.12.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.3-.79-.72-1.46-1.38-2.12C21.33 1.36 20.66.94 19.86.63 19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.41-10.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z',
  },
  {
    nombre: 'Facebook',
    url: 'https://www.facebook.com/LaboratoriosBacon/',
    path: 'M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.68 4.53-4.68 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z',
  },
  {
    nombre: 'YouTube',
    url: 'https://www.youtube.com/c/LaboratoriosBacon',
    path: 'M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19C0 8.08 0 12 0 12s0 3.92.5 5.81a3.02 3.02 0 0 0 2.12 2.14c1.88.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14C24 15.92 24 12 24 12s0-3.92-.5-5.81zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z',
  },
  {
    nombre: 'Sitio web',
    url: 'https://bacon.com.ar/',
    logo: '/img/logo.png',   // logo de la empresa en vez del icono de globo
  },
];

function Login() {
  const navigate = useNavigate();
  const [modo, setModo] = useState('login');

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [regForm, setRegForm] = useState({
    nombre: '', email: '', password: '', confirmar: '', numeroEquipo: '', empresa_nombre: '',
  });
  const [forgotEmail, setForgotEmail] = useState('');

  const [error, setError]   = useState('');
  const [exito, setExito]   = useState('');
  const [cargando, setCargando] = useState(false);

  const cambiarModo = (m) => { setModo(m); setError(''); setExito(''); };

  const handleLogin = async (e) => {
    e.preventDefault(); setError(''); setCargando(true);
    try {
      const res = await axios.post(`${API}/api/auth/login`, loginForm);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally { setCargando(false); }
  };

  const handleRegistro = async (e) => {
    e.preventDefault(); setError(''); setExito('');
    if (regForm.password !== regForm.confirmar) { setError('Las contraseñas no coinciden'); return; }
    if (regForm.password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    setCargando(true);
    try {
      const res = await axios.post(`${API}/api/auth/register`, {
        nombre:        regForm.nombre,
        email:         regForm.email,
        password:      regForm.password,
        numeroEquipo:  regForm.numeroEquipo.trim().toUpperCase(),
        empresa_nombre: regForm.empresa_nombre,
      });
      setExito(`¡Registro exitoso! Empresa: ${res.data.empresa || ''}. Ya podés iniciar sesión.`);
      setRegForm({ nombre: '', email: '', password: '', confirmar: '', numeroEquipo: '', empresa_nombre: '' });
      setTimeout(() => cambiarModo('login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al registrarse');
    } finally { setCargando(false); }
  };

  const handleForgot = async (e) => {
    e.preventDefault(); setError(''); setExito(''); setCargando(true);
    try {
      const res = await axios.post(`${API}/api/auth/forgot-password`, { email: forgotEmail });
      setExito(res.data.mensaje);
      setForgotEmail('');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al procesar la solicitud');
    } finally { setCargando(false); }
  };

  return (
    <div className="login-fondo">
      <div className="login-panel-izq">
        <div className="login-panel-contenido">
          <img src="/img/BAC-MT.png" alt="BAC MT" className="login-img" />
          <h1 className="login-panel-titulo">BAC MT</h1>
          <p className="login-panel-desc">
            Plataforma de monitoreo en tiempo real para su dispositivo de
            marcación y control de Kits empleados en estudios cardiológicos y neurológicos.
          </p>
        </div>
      </div>

      <div className="login-panel-der">
        <div className="login-card">

          {modo !== 'forgot' && (
            <div className="login-tabs">
              <button className={`login-tab ${modo==='login'?'login-tab-activo':''}`} onClick={() => cambiarModo('login')}>Iniciar sesión</button>
              {/* <button className={`login-tab ${modo==='registro'?'login-tab-activo':''}`} onClick={() => cambiarModo('registro')}>Registrarse</button> */}
            </div>
          )}

          {modo === 'login' && (
            <>
              <p className="login-card-sub">ACCESO AL SISTEMA</p>
              <form onSubmit={handleLogin} className="login-form">
                <div className="login-campo">
                  <label className="login-label">Correo electrónico</label>
                  <input type="email" value={loginForm.email}
                    onChange={e => setLoginForm({...loginForm, email: e.target.value})}
                    placeholder="usuario@empresa.com" className="login-input" required />
                </div>
                <div className="login-campo">
                  <label className="login-label">Contraseña</label>
                  <input type="password" value={loginForm.password}
                    onChange={e => setLoginForm({...loginForm, password: e.target.value})}
                    placeholder="••••••••" className="login-input" required />
                </div>
                {error && <div className="login-error">⚠ {error}</div>}
                <button type="submit" className="login-btn" disabled={cargando}>
                  {cargando ? 'Verificando...' : 'Ingresar al sistema'}
                </button>
              </form>
              <p className="login-link-alt">
                <button className="login-link-btn" onClick={() => cambiarModo('forgot')}>¿Olvidaste tu contraseña?</button>
              </p>
              <p className="login-link-alt">
                {/*  ¿No tenés cuenta?{' '}
                <button className="login-link-btn" onClick={() => cambiarModo('registro')}>Registrate</button> */}  
              </p>
            </>
          )}

          {modo === 'registro' && (
            <>
              <p className="login-card-sub">NUEVA CUENTA</p>
              <form onSubmit={handleRegistro} className="login-form">
                <div className="login-campo">
                  <label className="login-label">Número de equipo *</label>
                  <input type="text" value={regForm.numeroEquipo}
                    onChange={e => setRegForm({...regForm, numeroEquipo: e.target.value.toUpperCase()})}
                    placeholder="Ej: 5SQ9RSRA" className="login-input"
                    style={{fontFamily:'IBM Plex Mono, monospace', textTransform:'uppercase', letterSpacing:'0.1em'}}
                    required />
                  <span style={{fontSize:'0.72rem', color:'var(--text-dim)', marginTop:'4px'}}>
                    Número interno del dispositivo BAC MT
                  </span>
                </div>
                <div className="login-campo">
                  <label className="login-label">Nombre de la empresa / centro médico *</label>
                  <input type="text" value={regForm.empresa_nombre}
                    onChange={e => setRegForm({...regForm, empresa_nombre: e.target.value})}
                    placeholder="Ej: Laboratorio Santiago" className="login-input" required />
                </div>
                <div className="login-campo">
                  <label className="login-label">Tu nombre completo *</label>
                  <input type="text" value={regForm.nombre}
                    onChange={e => setRegForm({...regForm, nombre: e.target.value})}
                    placeholder="Nombre completo" className="login-input" required />
                </div>
                <div className="login-campo">
                  <label className="login-label">Correo electrónico *</label>
                  <input type="email" value={regForm.email}
                    onChange={e => setRegForm({...regForm, email: e.target.value})}
                    placeholder="admin@empresa.com" className="login-input" required />
                </div>
                <div className="login-campo">
                  <label className="login-label">Contraseña *</label>
                  <input type="password" value={regForm.password}
                    onChange={e => setRegForm({...regForm, password: e.target.value})}
                    placeholder="Mínimo 6 caracteres" className="login-input" required />
                </div>
                <div className="login-campo">
                  <label className="login-label">Confirmar contraseña *</label>
                  <input type="password" value={regForm.confirmar}
                    onChange={e => setRegForm({...regForm, confirmar: e.target.value})}
                    placeholder="Repetí la contraseña" className="login-input" required />
                </div>
                {error && <div className="login-error">⚠ {error}</div>}
                {exito && <div className="login-exito">✓ {exito}</div>}
                <button type="submit" className="login-btn" disabled={cargando}>
                  {cargando ? 'Registrando...' : 'Crear cuenta'}
                </button>
              </form>
              <p className="login-link-alt">
                ¿Ya tenés cuenta?{' '}
                <button className="login-link-btn" onClick={() => cambiarModo('login')}>Iniciá sesión</button>
              </p>
            </>
          )}

          {modo === 'forgot' && (
            <>
              <p className="login-card-sub">RESTABLECER CONTRASEÑA</p>
              <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)', marginBottom: '20px', lineHeight: '1.5' }}>
                Ingresá tu email y te enviamos un link para crear una nueva contraseña. El link expira en 1 hora.
              </p>
              <form onSubmit={handleForgot} className="login-form">
                <div className="login-campo">
                  <label className="login-label">Correo electrónico</label>
                  <input type="email" value={forgotEmail}
                    onChange={e => setForgotEmail(e.target.value)}
                    placeholder="usuario@empresa.com" className="login-input" required />
                </div>
                {error && <div className="login-error">⚠ {error}</div>}
                {exito && <div className="login-exito">✓ {exito}</div>}
                <button type="submit" className="login-btn" disabled={cargando}>
                  {cargando ? 'Enviando...' : 'Enviar link de restablecimiento'}
                </button>
              </form>
              <p className="login-link-alt">
                <button className="login-link-btn" onClick={() => cambiarModo('login')}>← Volver al login</button>
              </p>
            </>
          )}

          {/* ===== REDES SOCIALES ===== */}
          <div className="login-redes">
            {REDES.map(r => (
              <a key={r.nombre} href={r.url} target="_blank" rel="noopener noreferrer" aria-label={r.nombre} className="login-red">
                {r.logo ? (
                  <img src={r.logo} alt={r.nombre} className="login-red-logo" />
                ) : (
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                    <path d={r.path} />
                  </svg>
                )}
              </a>
            ))}
          </div>

          <p className="login-footer">
            <button className="login-link-btn" onClick={() => navigate('/terminos-condiciones')}>
              Términos y Condiciones
            </button>
            {' · '}
            <button className="login-link-btn" onClick={() => navigate('/politica-privacidad')}>
              Política de Privacidad
            </button>
          </p>
          <p className="login-footer" style={{ marginTop: '8px' }}>
            Copyright © 2026 Laboratorios Bacon
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;